import React from 'react'
import { Route, Redirect, Switch, Link } from 'react-router-dom'
import { Result, Button } from 'antd'
import Login from './pages/login'
import store from './store'
import { observer } from 'mobx-react'
import './App.scss'
import Home from './Home'

@observer
class App extends React.Component<any, any> {
    public componentDidMount() {
        window.addEventListener('resize', this.resizeListener)
        window.addEventListener('mousewheel', this.mousewheelListener)
    }

    public componentWillUnmount() {
        window.onresize = null
        window.removeEventListener('resize', this.resizeListener)
        window.removeEventListener('mousewheel', this.mousewheelListener)
    }

    public resizeListener() {
        const clientWidth = document.documentElement.clientWidth
        const clientHeight = document.documentElement.clientHeight
        store.resizeWindow(clientWidth, clientHeight)
    }

    public mousewheelListener(e: any) {
        // console.log(window.devicePixelRatio)
    }

    public render() {
        const { authStore } = store
        return (
            <Switch>
                <Route
                    exact={true}
                    path='/login'
                    render={(props) => {
                        return store.authStore.islogin ?
                            <Redirect to={authStore.selectDefaultPath()} {...props} /> : <Login {...props} />
                    }}
                />
                <Route
                    path='/'
                    component={Home}
                />
                <Route
                    path='/403'
                    exact={true}
                    render={() => {
                        return (
                            <Result
                                status='403'
                                title='403'
                                subTitle='You are not privileged to the page. Please contact the system administrator.'
                                extra={<Button type='primary'><Link to='/'>Back Home</Link></Button>}
                            />
                        )
                    }}
                />

                <Route
                    path='*'
                    render={() => {
                        return (
                            <Result
                                status='404'
                                title='404'
                                subTitle='Sorry, the page you visited does not exist.'
                                extra={
                                    (
                                        <Button type='primary'>
                                            <Link to='/'>Back Home</Link>
                                        </Button>
                                    )
                                }
                            />
                        )
                    }}
                />
            </Switch>
        )
    }
}
export default App
